import * as React from "react";
import { Sidebar, type NavSection } from "./Sidebar";
import { TopBar, type Crumb } from "./TopBar";
import { MobileMenu } from "./MobileMenu";

// Re-exported for backward compatibility (StratusDashboardLayout.tsx/
// FunderDashboardLayout.tsx import these from here) - the actual data now
// lives in navSections.ts, a leaf module with no dependency on Sidebar.tsx/
// AppShell.tsx, so domain/roleGuide.ts can source the same real nav data
// without creating a circular import back through here.
export { stratusNav, funderNav } from "./navSections";

/** Stratus / Funder layout: dark sidebar + top bar + content (+ optional right rail). */
export function AppShell({
  context,
  sections,
  crumbs,
  rightRail,
  children,
  showWorkspaceSwitcher = true,
}: {
  context: string;
  sections: NavSection[];
  crumbs: Crumb[];
  rightRail?: React.ReactNode;
  children: React.ReactNode;
  showWorkspaceSwitcher?: boolean;
}) {
  return (
    <div className="flex h-screen overflow-hidden bg-bg">
      <div className="hidden lg:flex">
        <Sidebar context={context} sections={sections} />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar
          crumbs={crumbs}
          showWorkspaceSwitcher={showWorkspaceSwitcher}
          menu={<MobileMenu context={context} sections={sections} />}
        />
        <div className="flex min-h-0 flex-1">
          <main className="min-w-0 flex-1 overflow-y-auto">{children}</main>
          <div className="hidden xl:flex">{rightRail}</div>
        </div>
      </div>
    </div>
  );
}
